// extracted by mini-css-extract-plugin
module.exports = {"footerMax":"Index_footerMax__23XAc","footer":"Index_footer__10MqL","footerH5":"Index_footerH5__n2rPS","animationFade":"Index_animationFade__1friN"};